import { MobileOnly } from "@/components/ui/ResponsiveTableList";
import type { ProveedorAdmin } from "@/lib/types";
import { ProveedorMobileCard } from "./ProveedorMobileCard";

export function ProveedoresMobileList({ items }: { items: ProveedorAdmin[] }) {
  return (
    <MobileOnly className="flex flex-col gap-2">
      {items.map((p) => (
        <ProveedorMobileCard key={p.numeroProveedor} prov={p} />
      ))}
    </MobileOnly>
  );
}
